import { render, staticRenderFns } from "./AccessCodeView.vue?vue&type=template&id=2870137a"
import script from "./AccessCodeView.vue?vue&type=script&lang=js"
export * from "./AccessCodeView.vue?vue&type=script&lang=js"
import style0 from "./AccessCodeView.vue?vue&type=style&index=0&id=2870137a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2870137a')) {
      api.createRecord('2870137a', component.options)
    } else {
      api.reload('2870137a', component.options)
    }
    module.hot.accept("./AccessCodeView.vue?vue&type=template&id=2870137a", function () {
      api.rerender('2870137a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/AccessCodeView.vue"
export default component.exports